import React from 'react'
import Fragment from '../common/fragment'

function FragmentDU(props) {
  return (
    <Fragment pos="uuuu" {...props}>
      <p>
El cuerpo de los mancebos ya era un espejo, oscuridad de la carne y de la muerte.
El dios se asomaba para ver su rostro humeante en un cuerpo cubierto de negro. Y
no veía nada, ni siquiera él podía traspasar la obscuridad del reflejo.
      </p>
    </Fragment>
  )
}


export default FragmentDU
